import { THeading } from '@modules/documents';
import { TMap } from '@shared/types';

/**
 * Used to generate a list of headings from a list of heading IDs.
 *
 * Filtering out any headings that are not found in the resolvedHeadings map.
 * Returning `undefined` if no headings are found indicating that an entire item is impacted.
 */
const resolveHeadings = (
  headingIds: string[] | undefined,
  resolvedHeadings: TMap<string, THeading>
): THeading[] | undefined => {
  if (!headingIds) return undefined;
  const headings = headingIds.map((id) => resolvedHeadings[id]).filter(Boolean);
  return headings.length > 0 ? headings : undefined;
};

export default resolveHeadings;
